import React, { useMemo, useState } from 'react';
import { IconButton, Flex, Box } from '@fullstory/components';
import { useIntl } from 'react-intl';
import { NotificationsSidecar } from '../../containers/NotificationsSidecar';
import { useFetchAllNotifications, useFetchUnreadNotificationCount } from '@fullstory/redux';
import { UnreadNotificationDot } from '../UnreadNotificationDot';

export interface NotificationsListButtonProps {}

export const NotificationsListButton: React.FC<NotificationsListButtonProps> = () => {
  const intl = useIntl();
  const [showSidecar, setShowSidecar] = useState(false);

  useFetchAllNotifications();
  const totalUnreadNotifications = useFetchUnreadNotificationCount();

  const anyUnreadNotifications = totalUnreadNotifications > 0;
  const notificationsTitle = useMemo(
    () =>
      anyUnreadNotifications
        ? intl.formatMessage(
            {
              defaultMessage:
                '{count, plural, one {# unread notifications} other {# unread notifications}}',
              id: 'JxsfZ4',
            },
            { count: totalUnreadNotifications },
          )
        : intl.formatMessage({ defaultMessage: 'Notifications', id: 'NAidKb' }),
    [intl, totalUnreadNotifications, anyUnreadNotifications],
  );

  return (
    <Flex data-component="NotificationsListButton" testId="notification-sidecar-button">
      <Box marginRight={8}>
        <UnreadNotificationDot unread={anyUnreadNotifications} offset={6}>
          <IconButton
            title={notificationsTitle}
            iconName="bell"
            onClick={() => setShowSidecar(true)}
            size="large"
          />
        </UnreadNotificationDot>
      </Box>
      <NotificationsSidecar onClose={() => setShowSidecar(false)} open={showSidecar} />
    </Flex>
  );
};
